var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconConsole = function SvgIconConsole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 7.5l2.5 2.5-2.5 2.5m4.166 0h2.5M2.5 5a1.667 1.667 0 011.667-1.667h11.666A1.666 1.666 0 0117.5 5v10a1.667 1.667 0 01-1.667 1.667H4.167A1.666 1.666 0 012.5 15V5z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconConsole;